import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {of} from 'rxjs';
import {switchMap, take} from 'rxjs/operators';

import {ApiService} from '../services/api.service';
import {KeycloakService} from '../services/keycloak.service';
import {ImpersonationService} from '../services/impersonation.service';

export const apiHeadersInterceptor: HttpInterceptorFn = (req, next) => {
    const apiService = inject(ApiService);

    if (!req.url.startsWith(apiService.baseUrl)) {
        return next(req);
    }

    const keycloakService = inject(KeycloakService);
    const oidcService = inject(OidcSecurityService);
    const impersonationService = inject(ImpersonationService);

    const impersonationToken = impersonationService.getToken();
    const tokenSource$ = impersonationToken
        ? of(impersonationToken)
        : oidcService.getAccessToken().pipe(take(1));

    return tokenSource$.pipe(
        switchMap(token => {
            let headers = req.headers;

            if (token && !headers.has('Authorization')) {
                headers = headers.set('Authorization', `Bearer ${token}`);
            }

            const organization = impersonationToken
                ? (impersonationService.impersonatedUser()?.organization ?? null)
                : (keycloakService.currentUser()?.organization?.[0] ?? null);

            if (organization && !headers.has('X-Tenant-ID')) {
                headers = headers.set('X-Tenant-ID', organization);
            } else if (!organization && !headers.has('X-Tenant-ID')) {
                console.warn('apiHeadersInterceptor: no organization; sending request without X-Tenant-ID', req.url);
            }

            return next(req.clone({headers}));
        })
    );
};
